<template>
  <el-container>
    <div style="flex: 1;">
      <el-form
        ref="ruleForm"
        :model="form"
        :inline="true"
        :rules="rules"
        size="small"
        style="position: relative;"
      >
        <el-form-item label="平台单号：">
          <el-input v-model.trim="form.pcode" />
        </el-form-item>
        <el-form-item label="电商单号：">
          <el-input v-model.trim="form.orderNo" />
        </el-form-item>
        <el-form-item label="顾客ID：">
          <el-input v-model.trim="form.buyer" />
        </el-form-item>

        <el-form-item style="position: absolute; right: 0; top: 5px; margin-right: 0;">
          <span class="expand-label" v-if="expanded" @click="handleExpandChange(false)">
            <span>收起</span>
            <span class="el-icon-arrow-up"></span>
          </span>
          <span class="expand-label" v-else @click="handleExpandChange(true)">
            <span>展开</span>
            <span class="el-icon-arrow-down"></span>
          </span>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="reset">重置</el-button>
        </el-form-item>

        <el-collapse-transition>
          <div v-if="expanded">
            <el-form-item label="审核日期：" prop="auditEndTime">
              <el-date-picker v-model="form.auditBeginTime" type="date" placeholder="开始时间" />
              <span class="start-end-text">至</span>
              <el-date-picker v-model="form.auditEndTime" type="date" placeholder="结束时间" />
            </el-form-item>

            <el-form-item label="产品上市：" prop="productOnMarketEndTime">
              <el-date-picker v-model="form.productOnMarketBeginTime" type="date" placeholder="开始时间" />
              <span class="start-end-text">至</span>
              <el-date-picker v-model="form.productOnMarketEndTime" type="date" placeholder="结束时间" />
            </el-form-item>

            <el-form-item label="订单交期：">
              <el-radio-group v-model="form.orderDeliveries">
                <el-tooltip effect="dark" placement="top" content="取“VSO”“特急”“紧急程度-高”中“未来10天”“10天之后”的部分。">
                  <el-radio label="1">紧急</el-radio>
                </el-tooltip>
                <el-tooltip effect="dark" placement="top" content="取“VSO”“特急”“紧急程度-高/中/低/默认”中“历史缺货”的部分。">
                  <el-radio label="0">超期</el-radio>
                </el-tooltip>
                <el-tooltip effect="dark" placement="top" content="根据 ECO 开单规则，取“紧急程度：中/低/默认”中的“未来10天”部分。">
                  <el-radio label="2">即将超期</el-radio>
                </el-tooltip>
                <el-tooltip effect="dark" placement="top" content="根据 ECO 开单规则，取“紧急程度：中/低/默认”中的“10天以后”部分。">
                  <el-radio label="3">正常</el-radio>
                </el-tooltip>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="新品标识：">
              <el-radio-group v-model="form.newTag">
                <el-radio :label="''">全部</el-radio>
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="发货周期：">
              <el-checkbox-group v-model="form.deliveryCycles">
                <el-checkbox label="1">≤7</el-checkbox>
                <el-checkbox label="2">7-30</el-checkbox>
                <el-checkbox label="3">≥30</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item label="商品编码：">
              <el-input v-model.trim="form.goodsCode" />
            </el-form-item>
            <el-form-item label="商品名称：">
              <el-input v-model.trim="form.goodsName" />
            </el-form-item>
            <el-form-item label="产品编码：">
              <el-input v-model.trim="form.productCode" />
            </el-form-item>
            <el-form-item label="产品名称：">
              <el-input v-model.trim="form.productName" />
            </el-form-item>
            <el-form-item label="包件编码：">
              <el-input v-model.trim="form.packCode" />
            </el-form-item>
            <el-form-item label="包件名称：">
              <el-input v-model.trim="form.packName" />
            </el-form-item>

            <el-form-item label="平台名称：">
              <el-select v-model="form.platformIds" multiple collapse-tags placeholder="请选择">
                <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="店铺名称：">
              <el-select v-model="form.storeIds" multiple collapse-tags placeholder="请选择">
                <el-option
                  v-for="item in storeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="是否国补：" v-if="['orders', 'nonStockOrders'].includes(activeName)">
              <el-select v-model="form.isStateSubsidies" placeholder="请选择">
                <el-option label="是" :value="1" />
                <el-option label="否" :value="0" />
              </el-select>
            </el-form-item>

            <el-form-item label="国补类型：" v-if="['orders', 'nonStockOrders'].includes(activeName)">
              <el-select v-model="form.type" multiple clearable collapse-tags @change="typeChange">
                <el-option v-show="!all" label="全部" value="" />
                <el-option v-show="all" label="取消全部" value="cancleAll" />
                <el-option
                  v-for="item in typeList"
                  :key="item.stateSubsidiesCode"
                  :label="item.stateSubsidiesName"
                  :value="item.stateSubsidiesCode"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="通用件标识：">
              <el-radio-group v-model="form.commonTag">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-collapse-transition>
      </el-form>
    </div>
  </el-container>
</template>

<script>
export default {
  model: {
    prop: 'formData',
    event: 'input'
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    activeName: String
  },
  data () {
    const checkEndDate = (rule, value, callback) => {
      if (value === undefined) {
        callback()
        return
      }
      let startDate
      let endDate
      if (rule.field === 'auditEndTime') {
        startDate = this.form.auditBeginTime
        endDate = this.form.auditEndTime
      } else if (rule.field === 'productOnMarketEndTime') {
        startDate = this.form.productOnMarketBeginTime
        endDate = this.form.productOnMarketEndTime
      }
      startDate = startDate && new Date(startDate).getTime()
      endDate = endDate && new Date(endDate).getTime()
      if (startDate > endDate) {
        callback(new Error('结束时间不能早于开始时间'))
      } else {
        callback()
      }
    }

    return {
      form: {},
      rules: {
        auditEndTime: [{ validator: checkEndDate, trigger: 'change' }],
        productOnMarketEndTime: [{ validator: checkEndDate, trigger: 'change' }]
      },
      expanded: false,
      all: false,
      platformList: [],
      storeList: [],
      typeList: []
    }
  },
  watch: {
    formData: {
      handler (val) {
        this.form = JSON.parse(JSON.stringify(val))
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.handleChartsRadioChange()
    this.getSelectOpt()
    this.getTypeOptions()
  },
  methods: {
    search () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.updateFormData()
          this.$emit('search', this.form)
        } else {
          this.$message.error('表单提交有误，请检查数据有效性')
        }
      })
    },
    clearFormData () {
      this.form = {
        newTag: '',
        outStockOrder: '',
        orderDeliveries: '',
        deliveryCycles: [],
        platformIds: [],
        storeIds: [],
        commonTag: ''
      }
      this.updateFormData()
    },
    reset () {
      this.clearFormData()
      this.$emit('search', this.form)
    },
    updateFormData () {
      this.$emit('input', this.form)
    },
    handleExpandChange (status) {
      this.expanded = status
    },
    getSelectOpt () {
      this.$q.orderDate.deliveryGetOptions().then((res) => {
        if (res.success === true && res.data) {
          this.platformList = res.data.platformList
          this.storeList = res.data.storeList
        }
      })
    },
    handleChartsRadioChange () {
      this.$bus.$on('updateChartsData', (data) => {
        if (data === '1') {
          this.$set(this.form, 'auditBeginTime', this.lastMonthData()[0])
          this.$set(this.form, 'auditEndTime', this.lastMonthData()[1])
        } else if (data === '2') {
          this.$set(this.form, 'auditBeginTime', this.thisMonthData()[0])
          this.$set(this.form, 'auditEndTime', this.thisMonthData()[1])
        } else if (data === '3') {
          this.$set(this.form, 'auditBeginTime', this.lastHalfMonthData()[0])
          this.$set(this.form, 'auditEndTime', this.lastHalfMonthData()[1])
        } else if (data === '') {
          this.$set(this.form, 'auditBeginTime', this.allMonthData()[0])
          this.$set(this.form, 'auditEndTime', this.allMonthData()[1])
        }
        this.search()
      })
    },
    lastMonthData () {
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      return [new Date(year, month - 1, 1), new Date(year, month, 0)]
    },
    thisMonthData () {
      const year = new Date().getFullYear()
      const month = new Date().getMonth() + 1
      return [new Date(year, month - 1, 1), new Date(year, month, 0)]
    },
    lastHalfMonthData () {
      return [new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 15), new Date()]
    },
    allMonthData () {
      return ['', '']
    },
    typeChange (val) {
      this.all = this.typeList.length === val.length
      if (val.includes('')) {
        this.form.type = this.typeList.map(v => v.stateSubsidiesCode)
        this.all = true
      } else if (val.includes('cancleAll')) {
        this.form.type = []
        this.all = false
      }
    },
    getTypeOptions () {
      this.$q.configurationCenter.queryStateSubsidiesType().then((res) => {
        this.typeList = res.data
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-container
  background #ffffff
  border-radius 4px
  overflow hidden

>>> .el-form
  padding-top 10px
  padding-bottom 10px

>>> .el-select
  width 180px

 >>> .el-input, .el-input__inner
    width 130px !important

.start-end-text
  display inline-block
  width 24px
  text-align center
  color #909399

.expand-label
  margin-right 12px
  cursor pointer
  color #606266

>>> .el-form-item__label
  color #606266
</style>
